/**
 * Map from auth config keys to their values
 * E.g. Map { AuthHandlers → "io.deephaven.auth.AnonymousAuthenticationHandler" }
 */

/**
 * Props for the auth plugin component to render
 */

/**
 * Whether the auth plugin is available given the current configuration
 */

export function isAuthPlugin(plugin) {
  if (plugin == null) return false;
  var authPlugin = plugin;
  return authPlugin.Component !== undefined && typeof authPlugin.isAvailable === 'function';
}
//# sourceMappingURL=AuthPlugin.js.map